import React from 'react';
import { meeting, note } from '@/models';
import Icon from '@/components/Icon';
import s from './index.less';
import { elkLog } from '@/utils/elkReport';
import message from '@/components/Message';
import { useIntl } from 'umi';
import { ShareScreenFull } from '@/models/meeting';
import classNames from 'classnames';
interface OpenNoteBtnProps {
  onClick?: () => void;
  visible: boolean;
}

const OpenNoteBtn: React.FC<OpenNoteBtnProps> = (props) => {
  const { onClick, visible } = props;
  const { formatMessage } = useIntl();

  const openTools = () => {
    if (!note?.shareAnnotateEnabled) {
      // 开启批注
      elkLog('打开批注');
      API.api.webScreenShareV3.enableAnnotate
        .request({ meetingId: window.$meetingId }, { channelId: meeting?.info?.channelId })
        .then((res) => {
          if (res.data) {
            console.log('开启批注成功', res.data);
            elkLog('打开批注成功');
          }
        })
        .catch((err) => {
          elkLog('打开批注失败', err);
          if (err?.status === 530009) {
            message.info({
              content: formatMessage({ id: 'popoVersionOld' }),
              noIcon: true,
            });
          }
          if (err?.status === 530004) {
            message.info({
              content: formatMessage({ id: 'disableOpenAnnotate' }),
              noIcon: true,
            });
          }

          elkLog('开启批注失败', err);
        });
    }
    onClick?.();
  };

  return (
    <div
      className={classNames(
        s.openBtn,
        meeting?.shareScreenFull === ShareScreenFull.FULL ? s.fullOpenBtn : ''
      )}
      onClick={openTools}
      style={{ display: visible ? 'flex' : 'none' }}
      id="openNoteBtn"
    >
      <Icon name="icon-Union" mode="symbol" size={18} className={s.icon}></Icon>
    </div>
  );
};

export default OpenNoteBtn;
